import { AfterViewInit, Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivityService } from './../../../../api-services/activity.service';
import { ActivityLogFilter } from './../../../../models/activity-log-filter.model';
import { ActivityLog, ActivityType } from './../../../../models/activity-log.model';
import { MalihuScrollbarService } from 'ngx-malihu-scrollbar';
import { SharedService } from '../../../../services';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-activity-log',
  templateUrl: './activity-log.component.html',
  styleUrls: ['./activity-log.component.css']
})
export class ActivityLogComponent implements OnInit {

  @Input() userId: number;
  totalCount = 0;
  activities: ActivityLog[] = [] as ActivityLog[];
  activityLogFilter: ActivityLogFilter = {
    category: undefined,
    activityTypeIds: null,
    pageNumber: 1,
    pageSize: 20,
    isDashboard:true

  } as ActivityLogFilter;
  userid: string = localStorage.getItem('userId');
  allDataLoaded = false;
  activeList:boolean = false;
  selectedDateRange: number | null = undefined;

  activityDate = [
    { key: 7, value: "7 Days" },
    { key: 15, value: "15 Days" },
    { key: 30, value: "30 Days" },
    { key: 60, value: "60 Days" },
    { key: 90, value: "90 Days" },
    { key: 180, value: "180 Days" },
    { key: 365, value: "1 Year" }
  ]

  
  showLoader: boolean = false;
  
  constructor(private activityService: ActivityService,
    private mScrollbarService: MalihuScrollbarService,
    private sharedService: SharedService,
    private router: Router
  ) { }


  ngOnInit(): void {
    this.getActivityLogs();
  }

  filterActivityLogs() {
    this.totalCount = 0;
    this.allDataLoaded = false;
    this.activityLogFilter.pageNumber = 1;
    this.getActivityLogs()
  }

  getActivityLogs() {
    if (this.showLoader || this.allDataLoaded) return;

    this.showLoader = true;
    if (this.userId != null) {
      this.activityLogFilter.userId = this.userId;
    }
    this.activityService.getActivityLog(this.activityLogFilter).subscribe(
      (response: any) => {
        let data = response;
        data = data.map(el => ({
          ...el,
          createdDate: this.sharedService.convertUTCTimeToLocalTime(el.createdDate)
        }));
        this.activeList = true;
        if (this.activityLogFilter.pageNumber === 1) {
          this.activities = data;
        } else {

          this.activities = [...this.activities, ...data];
        }

        if (response != null && response.length > 0) {
          this.totalCount = response[0].totalCount;
        }

        if (this.activities.length >= this.totalCount) {
          this.allDataLoaded = true;
        }
        this.showLoader = false;
      },
      (error: any) => {
        console.log(error);
        this.showLoader = false;
      }

    );
  }

  ngAfterViewInit() {

  }

  onScroll(event: any) {

    if (this.showLoader || this.allDataLoaded) return;

    const element = event.target;

    const atBottom =
      element.scrollHeight - element.scrollTop <= element.clientHeight + 50;

    if (atBottom) {
      this.loadMore();
    }
  }


  loadMore() {
    if (this.showLoader || this.allDataLoaded) return;

    this.activityLogFilter.pageNumber++;
    this.getActivityLogs();
  }

  onDateRangeChange() {

    const days = this.selectedDateRange;

    if (!days) {
      this.activityLogFilter.fromDate = null;
      this.activityLogFilter.toDate = null;
      return;
    }

    const today = new Date();
    const fromDate = new Date();
    fromDate.setDate(today.getDate() - days);

    this.activityLogFilter.fromDate = fromDate;
    this.activityLogFilter.toDate = today;

    this.filterActivityLogs();
  }

  viewActivityReport() {
    if (this.userId != null) {
      localStorage.setItem('resportUserId', this.userId.toString());
    }
    this.router.navigate(['/reports/activity-log-report']);
  }


}
